module.exports = __webpack_public_path__ + "static/img/20.3e66857.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/20.png
// module id = uEpT
// module chunks = 1